// noinspection ES6UnusedImports
import React, {useEffect, useState} from 'react';
import StarsFilter from "./StarsFilter.jsx";
import ReviewToggleFilterSelect from "./ReviewToggleFilterSelect.jsx";
import ReviewSortFilter from "./ReviewSortFilterSelect.jsx";
import {BottomSheet, Button, Typography} from '@bonprix/design-system';
import Breakpoint from '@core/scripts/helper/breakpoint.js';

export default function ReviewFilters({
                                          filters,
                                          texts,
                                          stars,
                                          count,
                                          currentCount,
                                          sorting,
                                          averageRating,
                                          onFilter,
                                          onRemoveFilter,
                                          onRemoveAllFilters,
                                          onSort,
                                          currentSelectedItem
                                      }) {
    const [selectedFilters, setSelectedFilters] = useState({});

    const [update, setUpdate] = useState(Breakpoint.current().key); // State to trigger re-render on resize
    const [filterSheetOpen, setFilterSheetOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => setUpdate(Breakpoint.current().key);// Toggle state to force re-render
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const FILTER_TEXT_MAPPING = {
        STARS: texts.ada12_review_stars,
        SIZE: texts.ada12_review_size,
        BODY_HEIGHT: texts.ada12_review_bodyHeight,
        VARIANT: texts.ada12_review_variant,
    };

    const DEFAULT_FILTER_TEXT_MAPPING = {
        STARS: texts.ada_review_ratingFilter_0,
        SIZE: texts.ada_review_sizeFilter_0,
        BODY_HEIGHT: texts.ada_review_bodyHeightFilter_0,
        VARIANT: texts.ada_review_variantenFilter_0,
    };

    const filterFunction = (data) => {
        const newSelectedFilters = {...selectedFilters};
        newSelectedFilters[data.type] = data.value;
        setSelectedFilters(newSelectedFilters);
        onFilter?.(data);
    };

    const removeFilterFunction = (data) => {
        const newSelectedFilters = {...selectedFilters};
        delete newSelectedFilters[data.type];
        setSelectedFilters(newSelectedFilters);
        onRemoveFilter?.(data);
    };

    const removeAllFilters = () => {
        setSelectedFilters({});
        onRemoveAllFilters?.();
    };

    const toggleSheet = () => setFilterSheetOpen(filterSheetOpen => !filterSheetOpen);

    const starFilter = filters.find(filter => filter.type === 'STARS');
    const nonStarFilters = filters.filter(filter => filter.type !== 'STARS');

    return (
        <div className="review-filters">
            <StarsFilter filter={starFilter}
                         stars={stars}
                         count={count}
                         averageRating={averageRating}
                         texts={texts}
                         selectedFilters={selectedFilters}
                         onFilter={filterFunction}
                         onRemoveFilter={removeFilterFunction}/>

            <div className="pb-5">
                <Typography variant="body2">
                    {texts.mobile_filter_headline}
                    <Typography component={'span'} color={"on-bg-low"} variant="body2"> ({currentCount} {texts.ada_bewertungen})</Typography>
                </Typography>
            </div>

            {Breakpoint.keyIsIn(['start', 'small']) ? (
                <>
                    <div className={'flex gap-4 items-center'}>
                        <div className={'flex-1 review-filters__actions-small-sort_width'}>
                            <ReviewSortFilter key={'review--sort-filter'}
                                           texts={texts}
                                           onSort={onSort}
                                           sorting={sorting}
                                           currentSelectedItem={currentSelectedItem}/>
                        </div>
                        <div className={'shrink-1'}>
                            <Button variant="secondary" icon={"control-panel"} onClick={toggleSheet} contentWidth={true} small={false}>
                                {texts.filter_button}
                            </Button>
                        </div>
                    </div>

                    <BottomSheet isOpen={filterSheetOpen} onClose={toggleSheet}>
                        <div className={'px-4 pb-5'}>

                            {nonStarFilters.map((filter, index) => {
                                return (
                                    <ReviewToggleFilterSelect key={'review-filter-' + index}
                                                              filter={filter}
                                                              text={FILTER_TEXT_MAPPING[filter.type] + ':'}
                                                              defaultFilterValue={DEFAULT_FILTER_TEXT_MAPPING[filter.type]}
                                                              selectedFilters={selectedFilters}
                                                              onFilter={filterFunction}
                                                              onRemoveFilter={removeFilterFunction}
                                    />
                                );
                            })}

                            <div className={'text-center mb-1'}>
                                <Typography variant="body1" color={"on-bg-low"}>
                                    ({currentCount} {texts.ada_bewertungen})
                                </Typography>
                            </div>

                            <Button onClick={toggleSheet} variant="primary">{texts.filter_apply}</Button>
                        </div>

                    </BottomSheet>
                </>
            ) : (
                <>
                    <div className={'mb-4'}>
                        <ReviewSortFilter key={'review--sort-filter'}
                                           texts={texts}
                                           onSort={onSort}
                                           sorting={sorting}
                                           currentSelectedItem={currentSelectedItem}/>
                    </div>

                    {nonStarFilters.map((filter, index) => {
                        const text = FILTER_TEXT_MAPPING[filter.type] + ':';
                        const defaultFilterValue = DEFAULT_FILTER_TEXT_MAPPING[filter.type];
                        return (
                            <ReviewToggleFilterSelect key={'review-filter-' + index}
                                                  filter={filter}
                                                  text={text}
                                                  defaultFilterValue={defaultFilterValue}
                                                  selectedFilters={selectedFilters}
                                                  onFilter={filterFunction}
                                                  onRemoveFilter={removeFilterFunction}
                            />
                        );
                    })}
                </>
                )
            }

            {Object.keys(selectedFilters).length > 0 ?
                <div className={'mt-4'}><Button
                    onClick={removeAllFilters}
                    variant="secondary">{texts.au_reset_all_filter}</Button>
                </div>
                : null
            }
        </div>
    )

}
